import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-inline-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './inline-loading.component.html',
  styleUrl: './inline-loading.component.scss',
})
export class InlineLoadingComponent {
  readonly label = input.required<string>();
  /** When true, spinner + label are centered within the available width (e.g. card bodies). */
  readonly centered = input(false);
  /** When true, spinner is stacked above the label instead of inline. */
  readonly stacked = input(false);
}
